export const initialData = {
    isLoading: false
}

const loader = (state = initialData, action) => {
    console.log(action.type, action.payload)
    switch (action.type) {
        case 'IS_LOADING':
            return { ...state, isLoading: action.payload }
        default:
            return state
    }
}

export default loader


// WEBPACK FOOTER //
// ./src/redux/reducers/loading.js